import {    getFirestore,
            doc,
            setDoc, 
            getDoc,
            addDoc,
            getDocs,
            onSnapshot,
            collection,
            arrayUnion, arrayRemove,
            updateDoc} from "firebase/firestore";

import { fillMemberInfo, fillPendingRequestInfo } from "./firestoreUtils";
import { updateClubState } from "../store/clubSlice";
import { db} from "../persistence/firestoreModel"

let userClubsUnsubscribers = [];

export async function fetchAllClub(){ //hämtar alla bokklubbar från firestore
    const colRef = collection(db, "book_clubs");
    return await getDocs(colRef);  
}

/**
 * Saves the bookclub member objects with userid and their progress for the current book 
 */
export async function saveMembers(clubId, firebaseMembers){ 
    if (!firebaseMembers) {
        console.error("Cannot save members: firebaseMembers is null or undefined");
        return;
    }
    try{
    const clubDoc = doc(db, "book_clubs", String(clubId))
    await setDoc(clubDoc, {
        members: firebaseMembers},
        {merge: true}
    )
    }
    catch{
        console.error("Failed to save members", error)
    }
}

/**
 * Starts listning on changes for the users active clubs and dispatches actions to update the club objects in the model
 * uses fillmemberinfo and fillpendingreguestsinfo to fetch additional information about the members and pending members thats not 
 * stored in firestore
 */
export function userClubsStateListner(userClubs, dispatch) {

    userClubsUnsubscribers.forEach(unsub => unsub());
    userClubsUnsubscribers = [];


    userClubs.forEach(clubId => {
    const clubDoc = doc(db, "book_clubs", String(clubId));


        const unsub = onSnapshot(clubDoc, async (snapshot) => {

            const data = snapshot.data();
            
            const members = await fillMemberInfo(data?.members);
            const pendingRequests = await fillPendingRequestInfo(data?.pendingRequests)
    
            dispatch(updateClubState({
            clubId,
            name: data?.clubName ?? null,
            genre: data?.genre ?? null,
            adminId: data?.adminId,
            members: members ?? [],
            pendingRequests: pendingRequests ?? [],
            currentBookId: data?.currentBookId ?? null,
            currentBook: data?.currentBook ?? null,
            deadline: data?.deadline ?? null,
            clubReady: true
            }));
        }, 
        (error) =>{
            console.error(error)
        }

        )
        if(typeof(unsub) === "function")
            userClubsUnsubscribers.push(unsub);
    })
}

/**
 * Used to save changes in club to firestore, depending on the action different fields are set to update. 
 */
export async function saveClubState(clubId, fieldToUpdate) {
  try {
    const clubDoc = doc(db, "book_clubs", clubId);
    await setDoc(clubDoc, 
        fieldToUpdate,
        { merge: true });
  }
  catch (error) {
    console.error("Failed to save club state:", error);
  }
}

 /*
 * Remove a user from the clubs list of requests
  */
export async function removeUserFromRequests(clubId, userId) {
    try{
    const clubDoc = doc(db, "book_clubs", String(clubId))
    if (clubId == null || userId == null) {
        console.error("removeUserFromRequests: missing ids", { clubId, userId });
        return;
    }
    await updateDoc(clubDoc, {
        pendingRequests: arrayRemove(String(userId))
    })
    }   
    catch (error){
        console.error("Failed to update requests", error)
    }    
}

/**
 * Add a user to the list of requests 
 */
export async function addUserToRequests(clubId, userId) {
    try{
    const clubDoc = doc(db, "book_clubs", clubId)
    await updateDoc(clubDoc, {
        pendingRequests: arrayUnion(String(userId))
    })
    }
    catch(error){
        console.error("Failed to update requests", error)
    }
       
}

/**
 * Create a club doc in firebase, unique clubId is returned to be added to the user list of clubs etc. 
 */
export async function createClubFirebase(newClub){
    console.log("create club firebase")

        const clubDoc = await addDoc(collection(db, "book_clubs"), {
            clubName: newClub.clubName ?? null,
            genre: newClub.genre ?? null,
            adminId: newClub.adminId ?? null,
            members: newClub.members ?? [],
            pendingRequests: newClub.pendingRequests ?? []
        })
        
        return clubDoc.id


}
/**
 * Fetch information about a club from firestore
 */
export async function getClubInfo(clubId) {
    try{
        const clubDoc = doc(db, "book_clubs", String(clubId));
        const club = await getDoc(clubDoc, { source: "server" })
        return club.data() 
    }
    catch(error){
        console.error("Failed to get clubinfo", error)

    }
    
    
}


